<template>
    <small class="dev-only mb-2" id="program-info">
        <div class="mb-1">
            <strong>Program Info</strong>
            <small class="float-right"> <button class="btn btn-sm btn-link" @click="showInfo = !showInfo">{{ (showInfo) ? 'hide' : 'show' }}</button></small>
        </div>
        <table class="table table-bordered table-sm" v-show="showInfo">
            <thead>
                <tr>
                    <th>program_type</th>
                    <th>age_0-12: </th>
                    <th>age_13-24:</th>
                    <th>age_2-5:</th>
                    <th>day-length</th>
                    <th>feeds_under_12mo</th>
                    <th>feeds_over_12mo</th>
                    <th>meals_provided</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ (program.program_type_id == 2) ? 'FCCH' : 'Normal' }}</td>
                    <td>{{ (program['age_0-12'] == 1) ? 'yes' : 'no' }}</td>
                    <td>{{ (program['age_13-24'] == 1) ? 'yes' : 'no' }}</td>
                    <td>{{ (program['age_2-5'] == 1) ? 'yes' : 'no' }}</td>
                    <td>{{ (program.full_day == 1) ? 'full-day' : (program.full_day === 0) ? 'half-day' : '--' }}</td>
                    <td>{{ (program.feeds_under_12mo == 1) ? 'yes' : 'no' }}</td>
                    <td>{{ (program.feeds_under_12mo == 1) ? 'yes' : 'no' }}</td>
                    <td>{{ (program.meals_provided ==1) ? 'yes' : 'no' }}</td>
                </tr>
            </tbody>
        </table>
    </small>
</template>
<script>
    export default {
        props: {
            program: {
                required: true,
                type: Object
            }
        },
        data() {
            return {
                showInfo: false
            }
        }
    }
</script>